import { createSlice } from '@reduxjs/toolkit'
import { toast } from 'react-toastify';
import {
    CREATE_PAYMENT_REQUEST,
    ERROR_MESSAGE_401_UNAUTHORIZED,
    ERROR_MESSAGE_403_FORBIDDEN,
    GET_TRANSACTION_STATUS,
    HTTP_STATUS_CODE_401_UNAUTHORIZED,
    HTTP_STATUS_CODE_403_FORBIDDEN,
    LINK_TERMINAL_REQUEST,
    UNLINK_TERMINAL_REQUEST
} from "../../../Configs";
import { OnlineAPIServiceEngine } from '../../../Services/OnlineAPIServiceEngine';

export const OnlineAPISlice = createSlice({
    name: 'onlineapi',
    initialState: {
    },
    reducers: {

    },
})

export const { } = OnlineAPISlice.actions


export const PaymentRequest = (payload, callback, connectionId = null) => (dispatch) => {
    // Create headers object
    const headers = {};

    // Conditionally add connectionId header
    if (connectionId !== null) {
        headers['connectionId'] = connectionId;
    }

    OnlineAPIServiceEngine.post(CREATE_PAYMENT_REQUEST, payload, {
        headers: headers
    }).then(response => {
        callback(response, true);
    }).catch(
        error => {
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(error.response?.data, false);
        })
}

export const LinkTerminal = (payload, callback, connectionId = null) => (dispatch) => {
    // Create headers object
    const headers = {};

    // Conditionally add connectionId header
    if (connectionId !== null) {
        headers['connectionId'] = connectionId;
    }
    OnlineAPIServiceEngine.post(LINK_TERMINAL_REQUEST, payload, {
        headers: headers
    }).then(response => {
        callback(response, true);
    }).catch(
        error => {
            console.log("error", error)
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(error.response?.data, false);
        })
}


export const UnLinkTerminal = (payload, callback, connectionId = null) => (dispatch) => {
    // Create headers object
    const headers = {};

    // Conditionally add connectionId header
    if (connectionId !== null) {
        headers['connectionId'] = connectionId;
    }
    OnlineAPIServiceEngine.post(UNLINK_TERMINAL_REQUEST, payload, {
        headers: headers
    }).then(response => {
        callback(response, true);
    }).catch(
        error => {
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(error.response?.data, false);
        })
}


export const GetTransactionStatus = (reference, callback, connectionId = null) => (dispatch) => {
    // Create headers object
    const headers = {};

    // Conditionally add connectionId header
    if (connectionId !== null) {
        headers['connectionId'] = connectionId;
    }
    OnlineAPIServiceEngine.get('/in-store/api/v1/transaction/' + reference + '/status', {
        headers: headers
    }).then(response => {
        callback(response, true);
    }).catch(
        error => {
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(error.response?.data, false);
        })
}

export default OnlineAPISlice.reducer
